import { render, staticRenderFns } from "./publishButton.vue?vue&type=template&id=39d9d80f&scoped=true&"
import script from "./publishButton.vue?vue&type=script&lang=js&"
export * from "./publishButton.vue?vue&type=script&lang=js&"
import style0 from "./publishButton.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./publishButton.vue?vue&type=style&index=1&id=39d9d80f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d9d80f",
  null
  
)

export default component.exports